import { defaultPageProps } from '../../../../app/browser/analyticsDefaultProperties';

export default {
  identify: {},
  page: {
    name: 'SP : Welcome Business Description',
    properties: defaultPageProps,
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/businessDescriptionAnalytics.js